import { Currency } from '@ps/web-core-enums';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';
import { BonusFlags, isSingleTicket } from '../../../../../utils/bonus';

import CashBonus from './components/CashBonus/CashBonus';
import TournamentTickets from './components/TournamentTickets/TournamentTickets';

interface Props {
  isFirst: boolean;
  amount: number;
  bonus: number;
}

const ComposedBonusMessage: React.FC<Props> = ({ isFirst, amount, bonus }) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { bonusFlags, bonusCurrency } = preCashinInfo as PreCashinInfo;

  /* eslint-disable no-bitwise */
  const isTicketsAsBonusOnly = !!(bonusFlags & BonusFlags.TournamentTicketOnly);
  const isSingleTicketInSet = isSingleTicket(preCashinInfo as PreCashinInfo);
  const bonusFormatted = isTicketsAsBonusOnly ? (
    bonus
  ) : (
    // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
    <CurrencyAmount value={bonus} currency={Currency[bonusCurrency]} />
  );
  // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
  const formattedAmount = <CurrencyAmount value={amount} currency={Currency[bonusCurrency]} />;

  const props = {
    isFirst,
    amount,
    bonus,
    formattedAmount,
    bonusFormatted,
    isSingleTicketInSet
  };

  return isTicketsAsBonusOnly ? <TournamentTickets {...props} /> : <CashBonus {...props} />;
};

export default ComposedBonusMessage;
